export const KID_FRIENDLY_ERRORS = {
  country: 'Oops, this adventure map folded itself. Try another country!',
  discovery: 'Beary could not find that picture yet. Tap again in a moment.',
  audio: "Beary's voice is warming up. Try again soon.",
};

export function getKidFriendlyError(type = 'discovery') {
  return KID_FRIENDLY_ERRORS[type] || KID_FRIENDLY_ERRORS.discovery;
}
